import { render, staticRenderFns } from "./AiStartupsModal.vue?vue&type=template&id=eeee75de&scoped=true&"
import script from "./AiStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeee75de",
  null
  
)

export default component.exports